// @TODO dataLayer задается в index.html
const ga = {
    dataLayer: {
        push() {
            if (!window.dataLayer) {
                return;
            }

            window.dataLayer.push(...arguments);
        }
    }

};

export {
    ga,
}


// WEBPACK FOOTER //
// ./src/services/analytics/ga.js